/**
 * A page opened while signed out (a patient file from RelayMD, a bookmark) is remembered in the tab's sessionStorage
 * before the login screen loads, and the login goes back to it instead of the schedule. Only a path inside this app is
 * kept, never another origin, and only for 15 minutes.
 */
const KEY = 'loginReturn';
const TTL_MS = 15 * 60 * 1000;

const isAppPath = (path: unknown): path is string =>
  typeof path === 'string' && path.length <= 2000 && /^\/[^/\\]/.test(path) && !/^\/login(?:[/?#]|$)/.test(path);

export function rememberLoginReturn(url: string, storage: Storage = sessionStorage, now = Date.now()): void {
  if (isAppPath(url)) storage.setItem(KEY, JSON.stringify({ path: url, at: now }));
}

/** The remembered path, if there is a fresh one; it is spent either way. */
export function takeLoginReturn(storage: Storage = sessionStorage, now = Date.now()): string | null {
  const raw = storage.getItem(KEY);
  storage.removeItem(KEY);
  try {
    const { path, at } = JSON.parse(raw ?? 'null') ?? {};
    return isAppPath(path) && typeof at === 'number' && now - at >= 0 && now - at <= TTL_MS ? path : null;
  } catch {
    return null;
  }
}
